const enabled = (config, key) =>
  Boolean(
    config &&
      config.manageMemberships &&
      config.manageMemberships.enabled &&
      config.manageMemberships[key] &&
      config.manageMemberships[key].enabled
  );

export const packageMembershipOptions = (ctx = {}) => {
  const config = ctx.config || {};
  const gymType = ctx.gymType || (ctx.gym && ctx.gym.type) || "";
  const options = [];
  if (enabled(config, "gymMemberships")) {
    if (gymType === "gym") {
      options.push({
        value: "GYM",
        aliases: ["Gym", "gym", "membership", "اشتراك", "نادي"],
      });
    } else {
      options.push({
        value: "court",
        aliases: ["Court", "rental court", "ملعب", "كور"],
      });
    }
  }
  if (enabled(config, "classMemberships")) {
    options.push({
      value: "class",
      aliases: [
        "Class",
        "class",
        "group session",
        "كلاس",
        "حصة",
        "حصة جماعية",
      ],
    });
  }
  if (enabled(config, "appointmentMemberships")) {
    options.push({
      value: "pt",
      aliases: [
        "Appointment",
        "PT",
        "private lesson",
        "موعد",
        "حصة خاصة",
      ],
    });
  }
  return options;
};

export const applyPackageVoiceFields = (fields, ctx) => {
  const membershipOptions = packageMembershipOptions(ctx);
  return fields.map((field) => {
    if (field.key === "title") {
      return { ...field, infer: "generate" };
    }
    if (field.key === "memberShipType") {
      return {
        ...field,
        infer: "intent",
        ...(membershipOptions.length ? { options: membershipOptions } : {}),
      };
    }
    if (field.key === "duration") {
      return {
        ...field,
        infer: "intent",
        options: [
          { value: "D", aliases: ["Days", "day", "أيام", "يوم"] },
          {
            value: "M",
            aliases: ["Months", "month", "monthly", "شهر", "شهري"],
          },
        ],
      };
    }
    if (field.key === "session") {
      return { ...field, default: "unlimited" };
    }
    if (field.key === "capacity") {
      return { ...field, default: "1" };
    }
    if (field.key === "pricingType") {
      return { ...field, default: "static" };
    }
    if (field.key === "gender") {
      return { ...field, required: false, assumed: "unrestricted" };
    }
    return field;
  });
};

export const applyAppointmentVoiceFields = (fields) =>
  fields.map((field) => {
    if (field.key === "name") {
      return { ...field, infer: "generate" };
    }
    if (field.key === "duration") {
      return {
        ...field,
        label: "Length in minutes",
        default: "60",
      };
    }
    return field;
  });

export const applyScheduledVoiceFields = (fields, type) =>
  fields.map((field) => {
    if (field.key === "name") {
      return { ...field, infer: "generate" };
    }
    if (field.key === "type") {
      return { ...field, default: "OFFLINE" };
    }
    if (field.key === "cancelBefore") {
      return { ...field, default: "1" };
    }
    if (field.key === "gender") {
      return { ...field, required: false, assumed: "unrestricted" };
    }
    if (type === "class" && field.key === "autoCreateSinglePackage") {
      return { ...field, default: "true" };
    }
    return field;
  });
